<template>
  <require from="controls/bs-form-lookup"></require>
  <div class="info-box">
    <div class="info-box-summary">
      <div class="info-box-caption">Search User</div>
      <div style="display: flex">
        <bs-form-lookup class="user-lookup" placeholder="Find by name, login or email" item.bind="model.user" options.bind="usersLookupOptions" value-path="name" template-path="templates/user-lookup.html" stick-mode="true" tooltip="Type to search for bp employee, then pick the one from the list" maxlength="100"></bs-form-lookup>
      </div>
    </div>
  </div>
</template>
